import { cn } from '@/lib/utils';
import * as React from 'react';

import { useFluidHoverGroupItem } from '@/components/ui/fluid-hover-group';

type RowButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
type RowLabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;
type RowDivProps = React.HTMLAttributes<HTMLDivElement>;

const FluidHoverButtonRow = React.forwardRef<HTMLButtonElement, RowButtonProps>(
    ({ className, type = 'button', ...props }, forwardedRef) => {
        const ref = useFluidHoverGroupItem<HTMLButtonElement>(forwardedRef);
        return (
            <button
                ref={ref}
                type={type}
                className={cn(
                    'relative z-10 w-full text-left outline-none focus-visible:ring-1 focus-visible:ring-focus-ring',
                    className
                )}
                {...props}
            />
        );
    }
);
FluidHoverButtonRow.displayName = 'FluidHoverButtonRow';

const FluidHoverLabelRow = React.forwardRef<HTMLLabelElement, RowLabelProps>(
    ({ className, ...props }, forwardedRef) => {
        const ref = useFluidHoverGroupItem<HTMLLabelElement>(forwardedRef);
        return (
            <label
                ref={ref}
                className={cn('relative z-10 cursor-pointer', className)}
                {...props}
            />
        );
    }
);
FluidHoverLabelRow.displayName = 'FluidHoverLabelRow';

const FluidHoverDivRow = React.forwardRef<HTMLDivElement, RowDivProps>(
    ({ className, ...props }, forwardedRef) => {
        const ref = useFluidHoverGroupItem<HTMLDivElement>(forwardedRef);
        return (
            <div ref={ref} className={cn('relative z-10', className)} {...props} />
        );
    }
);
FluidHoverDivRow.displayName = 'FluidHoverDivRow';

export { FluidHoverButtonRow, FluidHoverDivRow, FluidHoverLabelRow };
